const brandMap = {
  theverge: "I",
  vox: "H",
};

/*
  Sends events [page impressions, tout impressions, ]
*/
export const sendEventData = async (body: object) => {
  await fetch("/SendEventData", {
    method: "POST",
    body: JSON.stringify(body),
  }).catch(() => {
    // ignore if this tracking API throws an exception
  });
};

export const generateZephrTrackingId = async () => {
  await fetch("/blaize/anonymous-session", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  }).catch(() => {
    // ignore if this tracking API throws an exception
  });
};

type DataLayerResponse = {
  dataLayer: Record<string, string | null>;
};
export const getZephrExperimentsReadyEvent = async () => {
  const response = await fetch("/blaize/datalayer", {
    signal: AbortSignal.timeout(1000),
  });
  if (!response.ok) {
    return {};
  } else {
    const { dataLayer } = (await response.json()) as DataLayerResponse;
    const tracking_id = dataLayer.tracking_id;

    const brandEntry = Object.entries(brandMap).find(([brand]) =>
      location.hostname.includes(brand),
    );

    const brandCode = (brandEntry && brandEntry[1]) || "";

    const experiments = Object.entries(dataLayer)
      .filter(([key]) => key.startsWith(brandCode))
      .map(([key, value]) => `${key}${value}`)
      .join(",");

    return {
      event: "zephrExperimentsReady",
      experiments,
      tracking_id,
    };
  }
};
